import { Box } from "@mui/material";
import { sharedAws } from "../../../../../../service/bucketS3/Storage";
import { FileModal } from "../../../../../reportFolio/pages/dashboard/components/fileModal";
import { useEffect, useState } from "react";
import { EvidencesTypeValueEnum } from "../../../../../../utils/enums/evidences";


export const ViewFile = ({ fileKey, fileName, setViewFile, file }: {
    fileKey: string,
    fileName: string;
    setViewFile: React.Dispatch<React.SetStateAction<{
        fileKey: string;
        fileName: string;
    } | null>>;
    file?: File
}) => {

    const [modal, setModal] = useState({
        open: false,
        src: ''
    })

    const [component, setComponent] = useState<JSX.Element | null>(null)


    useEffect(() => {
        const fetchUrl = async () => {
            let fileUrl: string;

            if (file) {
                fileUrl = URL.createObjectURL(file);
            } else {
                fileUrl = await sharedAws.getDownloadUrl(fileKey, process.env.REACT_APP_BUCKET_FILES);
            }

            const viewerUrl = getViewerUrl(fileUrl, fileName);

            if (viewerUrl) {
                window.open(viewerUrl, "_blank", "noopener,noreferrer");
                setViewFile(null);
            }
        };

        fetchUrl();

        return () => {
            if (file) {
                URL.revokeObjectURL(file as unknown as string);
            }
        };
    }, [fileKey, fileName, file]);

    const getViewerUrl = (fileUrl: string, fileName: string) => {
        const ext = fileName.split('.').pop()?.toLowerCase();

        if (!ext) return fileUrl;

        if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext)) {
            const newUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fileUrl)}`;

            setModal(prev => ({ ...prev, open: true, src: newUrl }))
            setComponent(
                <Box>
                    <FileModal
                        src={newUrl}
                        modalProps={{ open: true, addClose: true, close: { onClick: closeModalMedia } }}
                        type={EvidencesTypeValueEnum.DOCUMENT}
                    />
                </Box>
            );
            return null;
        }

        if (['png', 'jpg', 'jpeg'].includes(ext)) {
            setModal(prev => ({ ...prev, open: true, src: fileUrl }))
            setComponent(
                <Box>
                    <FileModal
                        src={fileUrl}
                        modalProps={{ open: true, addClose: true, close: { onClick: closeModalMedia } }}
                        type={EvidencesTypeValueEnum.IMAGE}
                    />
                </Box>
            );

            return null;
        }

        if (['mp4', 'wma'].includes(ext)) {
            setModal(prev => ({ ...prev, open: true, src: fileUrl }))
            setComponent(
                <Box>
                    <FileModal
                        src={fileUrl}
                        modalProps={{ open: true, addClose: true, close: { onClick: closeModalMedia } }}
                        type={EvidencesTypeValueEnum.VIDEO}
                    />
                </Box>
            );
            return null;
        }

        if (['pdf', 'txt'].includes(ext)) {
            const newUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(fileUrl)}&embedded=true`;

            setModal(prev => ({ ...prev, open: true, src: newUrl }))
            setComponent(
                <Box>
                    <FileModal
                        src={newUrl}
                        modalProps={{ open: true, addClose: true, close: { onClick: closeModalMedia } }}
                        type={EvidencesTypeValueEnum.DOCUMENT}
                    />
                </Box>
            );
            return null;
        }

        return fileUrl;
    };

    function closeModalMedia() {
        setModal(prev => ({ ...prev, open: false }))
        setViewFile(null);
    }


    return (
        <>
            {modal.open && component}
        </>
    );
}